<template>
  <div style="display: flex; align-items: center">
    <b-form-group class="flex-grow-1 mr-2 mb-0">
      <b-form-select
        v-model="selectedSid"
        style="border: none"
        :options="domainOptions"
        value-field="sid"
        text-field="name"
        placeholder="Choose a domain"
        @change="onChange"
      />
    </b-form-group>
    <div class="favorites-wrapper">
      <b-button
        size="sm"
        class="btn btn-sm"
        :variant="
          favorites.some((d) => d.sid === selectedSid) ? 'info' : 'outline-info'
        "
        @click="addFavorite"
      >☆</b-button>
      <transition-group
        name="slide"
        tag="div"
        class="favorites-slide"
      >
        <b-button
          v-for="fav in favorites.filter((f) => f.sid !== selectedSid)"
          :key="fav.sid"
          size="sm"
          class="ml-0"
          :variant="fav.sid === selectedSid ? 'primary' : 'flat-info'"
          :disabled="fav.sid === selectedSid"
          @click="selectFavorite(fav.sid)"
        >
          {{ fav.name }}
        </b-button>
      </transition-group>
    </div>
  </div>
</template>

<script>
import useJwt from '@/cubus/jwt/useJwt'
import useCubus from '@/cubus/services/useCubus'
import { BButton, BFormGroup, BFormSelect } from 'bootstrap-vue'
import { getConfig } from '@/libs/axios'

export default {
  name: 'CbsDomainSelect',
  components: {
    BFormGroup,
    BFormSelect,
    BButton,
  },
  props: {
    domainSid: String,
  },
  data() {
    return {
      domains: [],
      selectedSid: null,
      favorites: [],
    }
  },
  computed: {
    domainOptions() {
      return this.domains.map(dom => ({ sid: dom.sid, name: dom.name }))
    },
  },
  mounted() {
    this.loadDomains()
    this.favorites = JSON.parse(
      localStorage.getItem(`${this.prefix()}domainFavorites`) || '[]',
    )
  },
  methods: {
    addFavorite() {
      const selected = this.domains.find(d => d.sid === this.selectedSid)
      if (selected && !this.favorites.find(f => f.sid === selected.sid)) {
        this.favorites.push(selected)
        localStorage.setItem(
          `${this.prefix()}domainFavorites`,
          JSON.stringify(this.favorites),
        )
        return
      }
      if (selected && this.favorites.find(f => f.sid === selected.sid)) {
        this.favorites = this.favorites.filter(f => f.sid !== selected.sid)
        localStorage.setItem(
          `${this.prefix()}domainFavorites`,
          JSON.stringify(this.favorites),
        )
      }
    },
    selectFavorite(sid) {
      this.selectedSid = sid
      this.onChange()
    },
    loadDomains() {
      useJwt
        .query({
          token: useJwt.getCubusToken(),
          query: {
            method: 'domains',
            param: {},
          },
        })
        .then(response => {
          if (response.data?.thread) {
            setTimeout(() => this.loadThread(response.data.thread), 500)
          }
        })
        .catch(error => {
          useCubus.toastError(this, error)
        })
    },
    loadThread(threadName) {
      useJwt
        .query({
          token: useJwt.getCubusToken(),
          query: {
            method: 'thread',
            param: { threadname: threadName },
          },
        })
        .then(response => {
          const thread = response.data?.thread
          if (thread?.status === 'done' && thread.result?.domains) {
            this.domains = thread.result.domains
            if (this.domainSid) {
              const match = this.domains.find(d => d.sid === this.domainSid)
              if (match) {
                this.selectedSid = match.sid
              }
            }
          } else {
            setTimeout(() => this.loadThread(threadName), 500)
          }
        })
        .catch(error => {
          useCubus.toastError(this, error)
        })
    },
    onChange() {
      const selected = this.domains.find(d => d.sid === this.selectedSid)
      if (selected) {
        this.enterDomain(selected)
      }
    },
    prefix() {
      const sess = useCubus.getSession()
      if (!sess || !sess.user || !sess.user.id) {
        console.warn('⚠️ Session or user not found in prefix()')
        return `${getConfig()}-anonymous-`
      }
      return `${getConfig()}-${sess.user.id}-`
    },
    // CUB-954: смена домена — `/api/domain/switch`, ТА ЖЕ сессия. Прежний `changedomain` выпускал
    // новый токен и гасил старый, а после входа из продукта это токен продукта: смена домена здесь
    // разлогинивала человека во второй вкладке продукта и ломала обратный переход.
    enterDomain(domain) {
      useJwt.axiosIns
        .post('/api/domain/switch', { domainsid: domain.sid })
        .then(() => useJwt.whoami({}))
        .then(response => {
          if (response.data?.error) {
            useCubus.toastError(this, response.data.error)
          } else if (response.data?.session) {
            useCubus.processLogin(this, response)
          }
        })
        .catch(error => {
          useCubus.toastError(this, error)
        })
    },
  },
}
</script>

<style scoped>
.favorites-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.favorites-slide {
  display: flex;
  overflow: hidden;
  max-width: 0;
  transition: max-width 0.3s ease-in-out;
  white-space: nowrap;
}

.favorites-wrapper:hover .favorites-slide {
  max-width: 500px; /* adjust based on expected number of favorites */
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}
</style>
